module.exports = __webpack_public_path__ + "fonts/outline-icons.ad97afd3.ad97afd3.ttf";